import React from "react";

import useDeliveryOrPickupAtController from "hooks/useDeliveryOrPickupAtController";

import OrderTimeSelectorRendererDesktop from "./OrderTimeSelectorRenderer.Desktop";

const SelectPickUpDateTimeDesktop = ({ visible }: { visible: boolean }) => {
	const rendererProps = useDeliveryOrPickupAtController({ visible });

	return !visible ? null : <OrderTimeSelectorRendererDesktop {...rendererProps} />;
};

export default SelectPickUpDateTimeDesktop;
